import { combineReducers } from "redux";
import _ from 'lodash';
import { API } from "../../../../const";
import { Service } from "../../../service/service"
import { OPEN_SNACKBAR_ERROR, OPEN_SNACKBAR_SUCCESS } from "../../../../reducers"
import { unAuthorized, logout } from '../../../auth/Auth.ducks'
import { getInfosCreche } from "./infoCreche.ducks";

// Absence actions

export const POST_NEW_STAFF_PENDING = "POST_NEW_STAFF_PENDING";
export const POST_NEW_STAFF_REJECTED = "POST_NEW_STAFF_REJECTED";
export const POST_NEW_STAFF_FULFILLED = "POST_NEW_STAFF_FULFILLED";

export const PUT_STAFF_PENDING = "PUT_STAFF_PENDING";
export const PUT_STAFF_REJECTED = "PUT_STAFF_REJECTED";
export const PUT_STAFF_FULFILLED = "PUT_STAFF_FULFILLED";

export const GET_STAFF_CRECHE_PENDING = "GET_STAFF_CRECHE_PENDING";
export const GET_STAFF_CRECHE_REJECTED = "GET_STAFF_CRECHE_REJECTED";
export const GET_STAFF_CRECHE_FULFILLED = "GET_STAFF_CRECHE_FULFILLED";

export const PUT_COUPLAGE_COMPTE_PENDING = "PUT_COUPLAGE_COMPTE_PENDING";
export const PUT_COUPLAGE_COMPTE_REJECTED = "PUT_COUPLAGE_COMPTE_REJECTED";
export const PUT_COUPLAGE_COMPTE_FULFILLED = "PUT_COUPLAGE_COMPTE_FULFILLED";

export const DELETE_AGENT_COMPTE_PENDING = "DELETE_AGENT_COMPTE_PENDING";
export const DELETE_AGENT_COMPTE_REJECTED = "DELETE_AGENT_COMPTE_REJECTED";
export const DELETE_AGENT_COMPTE_FULFILLED = "DELETE_AGENT_COMPTE_FULFILLED";

export const PUT_AGENT_SECTIONS_PENDING = "PUT_AGENT_SECTIONS_PENDING";
export const PUT_AGENT_SECTIONS_REJECTED = "PUT_AGENT_SECTIONS_REJECTED";
export const PUT_AGENT_SECTIONS_FULFILLED = "PUT_AGENT_SECTIONS_FULFILLED";
  const loading = (state = {}, { type }) => {
  switch (type) {
    case GET_STAFF_CRECHE_PENDING:
    case POST_NEW_STAFF_PENDING:
      return true;
    case GET_STAFF_CRECHE_REJECTED:
    case GET_STAFF_CRECHE_FULFILLED:
    case POST_NEW_STAFF_REJECTED:
    case POST_NEW_STAFF_FULFILLED:
      return false;
    default:
      return state;
  }
};

const error = (state = {}, { type, payload }) => {
  switch (type) {
    case POST_NEW_STAFF_PENDING:
    case POST_NEW_STAFF_FULFILLED:
    case GET_STAFF_CRECHE_PENDING:
    case GET_STAFF_CRECHE_FULFILLED:
      return null;
    case POST_NEW_STAFF_REJECTED:
    case GET_STAFF_CRECHE_REJECTED:
      return payload;
    default:
      return null;
  }
};

const data = (state = {}, { type, payload }) => {
  switch (type) {
    case GET_STAFF_CRECHE_FULFILLED:
      return _.isEmpty(payload.data) ? null : payload.data;
      case PUT_COUPLAGE_COMPTE_FULFILLED:{
        let newAgents=state.agents
        newAgents.forEach((element, index) => {
          if(element.id === payload) {
            newAgents[index]['agentActif'] = !state.agents[index]['agentActif'];
          }
      });
      let newState=Object.assign({},state,{'agents':newAgents})
         return  newState 

      }
    default:
      return state;
  }
};

// Absence reducer
export default combineReducers({ loading, error, data });

export const getStaffCreche = (tok) => {
  return (dispatch) => {
    dispatch({ type: GET_STAFF_CRECHE_PENDING })
    const response = Service.get(`${API}api/creche/agents`, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: GET_STAFF_CRECHE_FULFILLED, payload: res })
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: GET_STAFF_CRECHE_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    }
    )
  }
}

export const postNewStaff = (tok, data) => {
  return (dispatch) => {
    dispatch({ type: POST_NEW_STAFF_PENDING })
    const response = Service.post(`${API}api/creche/agents`, data, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: POST_NEW_STAFF_FULFILLED, payload: res })
      dispatch({ type: OPEN_SNACKBAR_SUCCESS })
      dispatch(getStaffCreche(tok))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: POST_NEW_STAFF_REJECTED, payload: err })
      dispatch({ type: OPEN_SNACKBAR_ERROR, payload: message })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    }
    )
  }
}
export const updateStaff = (tok, data,id, yesLogout) => {
  return (dispatch) => {
    dispatch({ type: PUT_STAFF_PENDING })
    const response = Service.put(`${API}api/creche/agents/${id}`, data, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: PUT_STAFF_FULFILLED, payload: res })
      dispatch({ type: OPEN_SNACKBAR_SUCCESS })
      dispatch(getStaffCreche(tok))
            if (yesLogout) {
              dispatch(logout())
            }
      dispatch(getInfosCreche(tok))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: PUT_STAFF_REJECTED, payload: err })
      dispatch({ type: OPEN_SNACKBAR_ERROR, payload: message })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    }
    )
  }
}
export const updateCouplageCompte = (tok, idAgent, data,yesLogout) => {
  return (dispatch) => {
    dispatch({ type: PUT_COUPLAGE_COMPTE_PENDING })
    const response = Service.put(`${API}api/creche/agents/${idAgent}/couplages`, data, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: PUT_COUPLAGE_COMPTE_FULFILLED, payload: idAgent })
      dispatch({ type: OPEN_SNACKBAR_SUCCESS })
      dispatch(getStaffCreche(tok))
      if (yesLogout) {
        dispatch(logout())
      }

    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: PUT_COUPLAGE_COMPTE_REJECTED, payload: err })
      dispatch({ type: OPEN_SNACKBAR_ERROR, payload: message })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    }
    )
  }
}
 export const deleteAgent = (tok,idAgent,yesLogout) => {
  return (dispatch) => {
    dispatch({ type: DELETE_AGENT_COMPTE_PENDING })
    const response = Service.deleteOne(`${API}api/creche/agents/${idAgent}`, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: DELETE_AGENT_COMPTE_FULFILLED, payload: idAgent })
      dispatch({ type: OPEN_SNACKBAR_SUCCESS })
      dispatch(getStaffCreche(tok))
      if (yesLogout) {
        dispatch(logout())
      }
      dispatch(getInfosCreche(tok))
 
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: DELETE_AGENT_COMPTE_REJECTED, payload: err })
      dispatch({ type: OPEN_SNACKBAR_ERROR, payload: message })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    }
    )
  }
}
export const updateAgentSections = (tok, agentId, data) => {
  return (dispatch) => {
    dispatch({ type: PUT_AGENT_SECTIONS_PENDING })
    const response = Service.put(`${API}api/creche/agents/${agentId}/sections`, data, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: PUT_AGENT_SECTIONS_FULFILLED, payload: res })
      dispatch({ type: OPEN_SNACKBAR_SUCCESS })
      dispatch(getStaffCreche(tok))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: PUT_AGENT_SECTIONS_REJECTED, payload: err })
      dispatch({ type: OPEN_SNACKBAR_ERROR, payload: message })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}
